/* udp-container-query-grid-item.css */
:host {
  display: block;
  width: 100%;
}